import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconStatus } from '../../interfaces/list-item.interfaces';

@Component({
  selector: 'app-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss']
})
export class ListItemComponent {
  // Content
  @Input() public title: string = "";
  @Input() public info: string = "";
  @Input() public info2: string = "";
  @Input() public disabled: boolean = false;
  @Input() public clickable: boolean = false;
  @Input() public disabledColorText: boolean = false;
  @Input() public selectable: boolean = false;
  @Input() public selected: boolean = false;

  @Input() public infoIcons: IconStatus[] = [];
  @Input() public infoIcons2: IconStatus[] = [];
  @Input() public itemStatusIcons: IconStatus[] = [];
  @Input() public actionIcon: IconStatus = {icon: "chevron_right"};

  @Input() public showItemStatus: boolean = false;
  @Input() public showActionIcon: boolean = false;
  @Input() public useLongPress: boolean = false;
  @Input() public itemStatusBadge: number = 0;
  @Input() public showSignalStrength: boolean = false;
  @Input() public showSignalStrengthNumeric: boolean = false;

  @Input() public signalStrength: number = 0;

  @Output() public onClickCallback = new EventEmitter<any>();
  @Output() public onItemStatusClickCallback = new EventEmitter<any>();
  @Output() public onActionClickCallback = new EventEmitter<any>();

  private timeout: number = null;
  private preventSimpleClick: Boolean = false;

  constructor() { }

  public itemClick(event: Event): void {
    this.timeout = window.setTimeout(() => {
      if (!this.preventSimpleClick) {
        this.onClickCallback.emit();
      }
      else{
        this.preventSimpleClick = false;
      }
    }, 250);
  }

  public itemStatusClick(event: Event): void {
    if (this.onItemStatusClickCallback.observers.length > 0) {
      event.stopPropagation();
      this.onItemStatusClickCallback.emit();
    }
  }

  public actionClick(event: Event): void {
    if (this.onActionClickCallback.observers.length > 0) {
      event.stopPropagation();
      this.onActionClickCallback.emit();
    }
  }
}
